// extracted by mini-css-extract-plugin
export default {"tab":"ScheduleTab_tab__yXUhK","scheduleName":"ScheduleTab_scheduleName__yq54L","message":"ScheduleTab_message__3a+KZ"};